


















import { Component, Prop, Vue } from 'vue-property-decorator'

// Interface
import { IPageFilterModel } from '@/_interfaces'

// Components
import FilterDropdown from '@/components/shared/FilterDropdown.vue'

@Component({
  components: { FilterDropdown },
})
export default class LabelButtonInput<T> extends Vue {
  @Prop()
  label!: string

  @Prop()
  pageFilters!: IPageFilterModel

  @Prop()
  filteredData!: T[]

  @Prop()
  onSelected?: (selected: T) => void

  handleSelected(option) {
    if (this.onSelected) {
      this.onSelected(option)
    }
  }
}
